export default {
  social: {
    facebookInit: false,
    googleInit: false,
  },
  visible: '',
  categories: null,
  event: {
    pan: false,
    swipeLeft: {},
    swipeRight: {},
  },
  menuLeft: {
    show: false,
    maximX: 30,
    minimY: 20,
  },
  menuRight: {
    show: false,
    page: '',
    maximX: 30,
    minimY: 20,
  },
};



// WEBPACK FOOTER //
// ./src/store/temp/temp.state.js